import { NgTemplateOutlet } from '@angular/common';
import { CommunityLoaderComponent } from '../community-loader/community-loader.component';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  contentChild,
  ElementRef,
  input,
  linkedSignal,
  output,
  TemplateRef,
  viewChild,
} from '@angular/core';

@Component({
  selector: 'outlaw-lazy-load-list',
  templateUrl: './lazy-load-list.component.html',
  styleUrls: ['./lazy-load-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, CommunityLoaderComponent],
})
export class LazyLoadListComponent implements AfterViewInit {
  items = input([]);
  isLoading = input<boolean>(false);
  canHideInfiniteScroll = input<boolean>(false);

  observerOptions = input<IntersectionObserverInit>({
    rootMargin: '0px', // No margin applied to the root element
    threshold: 1.0, // 100% of the element must be visible
  });

  getItemsEvent = output<void>();

  $items = linkedSignal(() => this.items());

  template = contentChild<TemplateRef<any>>(TemplateRef);
  infiniteScrollBlock = viewChild<ElementRef>('infiniteScroll');

  ngAfterViewInit(): void {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        this.getItemsEvent.emit();
      }
    }, this.observerOptions());

    if (this.infiniteScrollBlock()) {
      observer.observe(this.infiniteScrollBlock().nativeElement);
    }
  }

  removeItem(postUuid: string): void {
    this.$items.update(items => items.filter(item => item.post_uuid !== postUuid));
  }
}
